import shopifyEnterpriseGenericDefaults from '../shopify-enterprise-generic/config.js';

const AutoSyncKey = '09gv4m-m2';

const upsizeDownsizeFacetPanelFields = ['wheel_tire_diameter', 'FrontRear', 'tire_size'];

shopifyEnterpriseGenericDefaults.Widgets.map((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets') {
    if (w.ignoreFields) {
      w.ignoreFields.push(...upsizeDownsizeFacetPanelFields);
    } else {
      w.ignoreFields = upsizeDownsizeFacetPanelFields;
    }
  }
  return w;
});

const selectedStoreId = window.Titan?.utils?.getLocalStorageByKey('selectedStoreId');
const {
  priceBaseValue,
  phone: selectedStorePhone,
  storeName: selectedStoreName,
} = window.Titan?.utils?.getFormattedStoreData(
  window.Titan?.utils?.getLocalStorageByKey('selectedStoreData'),
) || {};

const tiresCollectionUrl = `${window.Convermax.Shopify?.getCollectionsPageUrl()}/tires`;
const wheelsCollectionUrl = `${window.Convermax.Shopify?.getCollectionsPageUrl()}/wheels`;

const isOnHomePage = window.Convermax.Shopify?.getPageType() === 'home';
const isOnCategoryListPage = window.document.querySelector('#cm-collection-list');

const wheelsFields = shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;
const tiresFields = shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;

const defaultRequestExtra = { ...shopifyEnterpriseGenericDefaults.SearchRequestDefaults.extra };
if (selectedStoreId) {
  defaultRequestExtra.selectedStoreId = selectedStoreId;
}
if (priceBaseValue) {
  defaultRequestExtra.priceBaseValue = priceBaseValue;
}

window.Convermax.isStoreSelected = !!selectedStoreId;
window.Convermax.selectedStoreName = selectedStoreName;
window.Convermax.selectedStorePhone =
  selectedStorePhone && selectedStorePhone.length === 10
    ? // 5132714422 -> (513) 271-4422
      `(${selectedStorePhone.slice(0, 3)}) ${selectedStorePhone.slice(3, 6)}-${selectedStorePhone.slice(6)}`
    : null;

const staggeredSearchFields = ['FrontRear', 'FrontProductID', 'RearProductID'];
window.Convermax.isOnStaggeredSearch = () =>
  staggeredSearchFields.some((f) => window.location.href.includes(f));

const noWheelImageSrc =
  'https://cdn.shopify.com/s/files/1/0912/8083/4875/files/noImageWheel.png?v=1753883124';
const noTireImageSrc = 'https://cdn.shopify.com/s/files/1/0912/8083/4875/files/noImageTire.png?v=1753883125';
window.Convermax.getProductImage = (fitmentType) => {
  return fitmentType === 'Wheel' ? noWheelImageSrc : fitmentType === 'Tire' ? noTireImageSrc : null;
};

window.Convermax.handleQtySelector = (target, formatPrice) => {
  const quantitySelectorInput = target.closest('.qty-input').querySelector('.qty-input__input');
  const addToCartForm = target.closest('form');
  const quantityFormInput = addToCartForm.querySelector('input[name="quantity"]');

  const currentQty = +quantitySelectorInput.getAttribute('value');
  if (
    // add max 7 products to cart per client request
    (target.classList.contains('btn--plus') && currentQty === 7) ||
    (target.classList.contains('btn--minus') && currentQty === 1)
  ) {
    return;
  }

  const newQty = target.classList.contains('btn--plus') ? currentQty + 1 : currentQty - 1;

  quantitySelectorInput.setAttribute('value', newQty);
  quantitySelectorInput.value = newQty;
  quantityFormInput.value = newQty;

  const priceContainer = target.closest('.card__info')?.querySelector('.titan-price');
  const regionalPrice = priceContainer?.getAttribute('data-regional-price');

  if (!regionalPrice) {
    return;
  }

  const leftPriceContainer = priceContainer.querySelector('.titan-left-price');
  const priceAmountContainer = leftPriceContainer.querySelector('.titan-price-amount');
  const compareAtPriceContainer = priceContainer.querySelector('.titan-right-price');

  const productQuantity = quantityFormInput.value;

  if (productQuantity >= 4) {
    const percentageDiscount = priceContainer.getAttribute('data-percentage-discount');
    const dollarsDiscount = priceContainer.getAttribute('data-dollars-discount');

    const discountAmount = +percentageDiscount + +dollarsDiscount / productQuantity;
    const newPrice = +regionalPrice - discountAmount;

    if (discountAmount > 0) {
      leftPriceContainer.classList.add('titan-price-green');
      priceAmountContainer.textContent = formatPrice(newPrice);
      compareAtPriceContainer.classList.remove('cm_hide');
    }
  } else {
    compareAtPriceContainer.classList.add('cm_hide');
    leftPriceContainer.classList.remove('titan-price-green');
    priceAmountContainer.textContent = formatPrice(regionalPrice);
  }
};

const baseUpdateCallback = shopifyEnterpriseGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchResult',
)?.updateCallback;
const updateCallback = () => {
  baseUpdateCallback?.();

  const isOnStaggeredSearch = window.Convermax.isOnStaggeredSearch();

  // revert product card qty selector and price to initial state
  [...window.document.querySelectorAll('.cm_SearchResult .card--product')].forEach((product) => {
    const quantitySelectorInput = product.querySelector('.qty-input__input');
    if (!quantitySelectorInput) {
      return;
    }

    const isFrontOrRear = product.getAttribute('data-staggered') === 'true' || isOnStaggeredSearch;
    const priceContainer = product.querySelector('.titan-price');
    const initialPrice = priceContainer.getAttribute('data-initial-price');

    priceContainer.querySelector('.titan-left-price .titan-price-amount').textContent = initialPrice;
    if (priceContainer.getAttribute('data-initial-discount') === '0' || isFrontOrRear) {
      priceContainer.querySelector('.titan-right-price').classList.add('cm_hide');
    } else {
      priceContainer.querySelector('.titan-right-price').classList.remove('cm_hide');
      priceContainer.querySelector('.titan-left-price').classList.add('titan-price-green');
    }

    const quantityFormInput = product.querySelector('form > input[name="quantity"]');

    const defaultQuantity = isFrontOrRear ? 2 : 4;
    quantitySelectorInput.setAttribute('value', defaultQuantity);
    quantitySelectorInput.value = defaultQuantity;
    quantityFormInput.value = defaultQuantity;
  });
};

window.Convermax.addStaggeredPackagesToCart = (product) => async (e) => {
  const { href, pathname } = window.location;
  const { _badges: badges, id: productId, variant_ids: variantIds } = product;
  const variantId = variantIds?.[0];

  const isFrontProduct = href.includes('FrontRear/Front') || badges?.some((b) => b === 'Front');
  const isRearProduct = href.includes('FrontRear/Rear') || badges?.some((b) => b === 'Rear');

  if (!isFrontProduct && !isRearProduct) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const redirectPath =
    href.includes('FrontProductID') || href.includes('RearProductID')
      ? '/cart'
      : isFrontProduct
        ? `${pathname}?FrontProductID/${productId}/${window.Convermax.getVehicleSearchParams()}`
        : `${pathname}?RearProductID/${productId}/${window.Convermax.getVehicleSearchParams()}`;

  const { add: cartAdd, root: cartRoot } = window.Convermax.Shopify.getCartUrls();

  fetch(`${cartAdd}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 2 }] }),
  })
    .then((response) => {
      if (response.ok) {
        window.location.replace(redirectPath);
      } else {
        console.error(response);
        // check if the cart is already contains this product
        fetch(`${cartRoot}.js`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.items?.some((i) => i.variant_id === +variantId)) {
              window.location.replace(redirectPath);
            } else {
              console.error(response);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

function onVerifyFitmentResponseReceived(response) {
  const visualizationContainer = window.document.querySelector('#cm-autosync-preview');
  if (visualizationContainer) {
    const item = response?.Items?.[0];
    const wheelMpn = item?.wheel_mpn;
    const fits = item?.fitsTheVehicle;

    if (!wheelMpn || !fits || fits !== 'yes') {
      visualizationContainer.classList.add('cm_hide');
      return;
    }

    if (!visualizationContainer.classList.contains('cm_view-on-vehicle-btn')) {
      visualizationContainer.innerHTML = 'See on your vehicle';
      visualizationContainer.classList.add('cm_view-on-vehicle-btn', 'btn', 'cm_btn--secondary');
      visualizationContainer.addEventListener('click', () =>
        window.Convermax.openVisualizationDialog(wheelMpn),
      );
    }

    visualizationContainer.classList.remove('cm_hide');
  }
}

export default {
  includes: ['shopify-enterprise-generic'],
  ...shopifyEnterpriseGenericDefaults,
  // because the tabs on search results trigger filters discarding
  disableRequestScroll: true,
  SearchRequestDefaults: {
    ...shopifyEnterpriseGenericDefaults.SearchRequestDefaults,
    pageSize: 20,
    extra: isOnCategoryListPage
      ? { ...defaultRequestExtra, formatWheelTireInfo: true }
      : { ...defaultRequestExtra },
  },
  autocomplete: {
    requestDefaults: {
      extra: { ...defaultRequestExtra, excludeParents: true },
    },
  },
  product: {
    ...shopifyEnterpriseGenericDefaults.product,
    searchResultsImageWidth: 300,
    searchResultsImageHeight: 300,
  },
  fitmentSearch: {
    ...shopifyEnterpriseGenericDefaults.fitmentSearch,
    forceVehicleSelection:
      isOnCategoryListPage || !!shopifyEnterpriseGenericDefaults.fitmentSearch.forceVehicleSelection,
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
  },
  facets: {
    ...shopifyEnterpriseGenericDefaults.facets,
    toggleFacet: [{ fields: ['on_deal'], term: 'True' }],
  },
  Widgets: [
    ...shopifyEnterpriseGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchResult',
          'SearchHeader',
          'Facets',
          'SearchVehicleWidget',
          'FacetCategoryTiles',
          'FacetBrandTiles',
          'VehicleWidgetDialog',
          'VerifyFitment',
          'Garage',
          'MobileGarage',
          'FacetBarWheels',
          'FacetBarTires',
          'VehicleSpecs',
        ].includes(w.name),
    ),
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      instantInfiniteScroll: !!window.Convermax.config?.instantInfiniteScroll,
      updateCallback,
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields: shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'Facets').ignoreFields,
      initCollapsed: true,
      initExpandedFacets: ['Inventory'],
    },
    {
      name: 'HeaderVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-home-ymm',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 700,
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : null,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-tire',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      selectFields: tiresFields,
      shouldBeIsolated: () => window.location.pathname !== tiresCollectionUrl,
      redirectUrl: tiresCollectionUrl,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-wheel',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      selectFields: wheelsFields,
      shouldBeIsolated: () => window.location.pathname !== wheelsCollectionUrl,
      redirectUrl: wheelsCollectionUrl,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: upsizeDownsizeFacetPanelFields,
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      autoSyncVisualization: {
        apiKey: AutoSyncKey,
        config: {
          height: '100px',
        },
      },
    },
    {
      name: 'AutoSyncVisualizationDialog',
      apiKey: AutoSyncKey,
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
    {
      name: 'CategoryListPage',
      type: 'SearchPage',
      location: '#cm-collection-list',
      template: 'CategoryListPage',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      columnBreakpoint: 600,
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      columnBreakpoint: 600,
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
      facetField: 'Brand',
      view: 'grid',
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters &&
        shopifyEnterpriseGenericDefaults.fitmentSearch.baseFields,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'Garage',
      location: {
        selector: '#cm-garage',
        class: 'header__icon',
      },
      template: 'fitmentSearch/garage',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : null,
      useVehicleWidget: true,
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: '#cm-mobile-garage',
      template: 'fitmentSearch/garage',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : null,
      useVehicleWidget: true,
    },
  ],
};
